import React, { useState } from 'react';

import AssetUpload from '../../../apps/pro/views/Album/AlbumSlideshow/AlbumSlideshowDesignerView/components/PhotoSelectionOverlayModal/components/AssetUpload';
import Button from '../../../components/global/Button';

const AssetImageUpload = () => {
  const [assetImage, setAssetImage] = useState(null);

  if (assetImage) {
    return (
      <div className="text-center p-4">
        <h3>Success!</h3>
        <img src={assetImage.url} alt="FAILED" style={{ width: '50%' }} />
        <p>
          Your asset image id is <b>{assetImage.id}</b>
        </p>
        <Button className="mt-2" onClick={() => setAssetImage(null)}>
          Upload another one
        </Button>
      </div>
    );
  }
  return (
    <div className="text-center p-4">
      <AssetUpload onUploaded={asset => setAssetImage(asset)} />
    </div>
  );
};

export default AssetImageUpload;
